import { Field, getData, Group } from "./GeneralForm"

export function validate(config, data) {
  const errors = []
  for (const lines of config) {
    for (const field of lines) {
      validateField(field, data, errors)
    }
  }
  return errors
}

function validateField(field, data, errors) {
  if (field.disabled || field.hide)
    return true

  if (field.type === 'text')
    return validateText(field, data, errors)

  if (field.type === 'cnpj')
    return validateCnpj(field, data, errors)

  if (field.type === 'cpf')
    return validateCpf(field, data, errors)

  if (field.type === 'combo')
    return validateCombo(field, data, errors)

  if (field.type === 'radio')
    return validateRadio(field, data, errors)

  if (field.type === 'integer')
    return validateInteger(field, data, errors)

  if (field.type === 'decimal')
    return validateDecimal(field, data, errors)

  if (field.type === 'signeddecimal')
    return validateDecimal(field, data, errors)

  if (field.type === 'textarea')
    return validateText(field, data, errors)

  if (field.type === 'cep')
    return validateCep(field, data, errors)

  if (field.type === 'date')
    return validateDate(field, data, errors)

  if (field.type === 'phone')
    return validatePhone(field, data, errors)

  if (field.type === 'bankAccount')
    return validateBankAccount(field, data, errors)

  if (field.type === 'email')
    return validateEmail(field, data, errors)
}

function validateImagemWithPreview(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateText(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateCnpj(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (value.length != 14) { // pode-se adicionar aqui uma função que valida o CNPJ
      addError(errors, field.name, "Valor inválido")
    }
  } else {
    if (value && value.length != 14) { // pode-se adicionar aqui uma função que valida o CNPJ
      addError(errors, field.name, "Valor inválido")
    }
  }
}

function validateCpf(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (value.length != 11) { // pode-se adicionar aqui uma função que valida o CPF
      addError(errors, field.name, "Valor inválido")
    }
  } else {
    if (value && value.length != 11) { // pode-se adicionar aqui uma função que valida o CPF
      addError(errors, field.name, "Valor inválido")
    }
  }
}

function validateCombo(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateRadio(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateInteger(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateDecimal(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validateCep(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (value.length != 8) {
      addError(errors, field.name, "Valor inválido")
    }
  } else {
    if (value && value.length != 8) {
      addError(errors, field.name, "Valor inválido")
    }
  }
}

function validateDate(field, data, errors) {
  // tem que testar o que acontece quando informamos uma data inválida no campo... a princípio deve gerar uma data 0/0/0
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    }
  }
}

function validatePhone(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (value.length != 14 && value.length != 15) {
      addError(errors, field.name, "Valor inválido")
    }
  } else {
    if (value && value.length != 14 && value.length != 15) {
      addError(errors, field.name, "Valor inválido")
    }
  }
}

function validateBankAccount(field, data, errors) {
  // este é o único campo que salva formatação por um motivo, ele é exibido com dígito na tela e o - é usado para separar o valor em conta e dígito
  // ao gerar o payload é feito split e o indice 0 é o número da conta enquanto o índice 1 é o digito
  // por este motivo a conta bancária deve ter no mínimo 3 caracteres, sendo o número da conta com no mínimo 1 caracter mais o - + o dígito com 1 caractere
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (value.length < 3) {
      addError(errors, field.name, "Valor inválido")
    }
  } else {
    if (value && value.length < 3) {
      addError(errors, field.name, "Valor inválido")
    }
  }
}

function validateEmail(field, data, errors) {
  const value = getData(data, field.name)
  if (field.required) {
    if (!value) {
      addError(errors, field.name, "Campo obrigatório")
    } else if (!validateEmail(value)) {
      addError(errors, field.name, "E-mail inválido")
    }
  } else {
    if (value && !validateEmail(value)) {
      addError(errors, field.name, "E-mail inválido")
    }
  }
}

export function addError(errors, fieldName, error) {
  errors.push({
    fieldName,
    error
  })
}